import { SectionTitle } from "../sectionTitle";

export const DefaultSection = ({ title, children }) => {
  return (
    <div>
      <SectionTitle title={title} />
      {children}
    </div>
  );
};
